import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Box,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import axios from '../../axiosConfig';
import './animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
  // textAlign: 'center',
});

const BuyerMasters = () => {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ'
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  // alert messages on operations
  const [alertType, setAlertType] = useState('success'); // 'success' or 'error'
  const [alertMessage, setAlertMessage] = useState('');

  const [errors, setErrors] = useState({
    buyerName: false,
    address: false,
    Country: false,
    Email: false,
    Contactperson: false,
    contactNo: false,
    Active: false,
  });
  const [helperTexts, setHelperTexts] = useState({
    buyerName: '',
    address: '',
    Country: '',
    Email: '',
    Contactperson: '',
    contactNo: '',
    Active: '',
  });

  // input fields state values
  const [buyerName, setbuyerName] = useState('');
  const [address, setaddress] = useState('');
  const [country, setCountry] = useState('');
  const [countryData, setCountryData] = useState('');
  const [Email, setEmail] = useState('');
  const [Contactperson, setContactperson] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [Active, setActive] = useState('Y');
  const [buyersData, setBuyersData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [editID, setEditID] = useState();
  const [IdToDelete, setIdToDelete] = useState(null);

  const [openLoader, setOpenLoader] = useState(false);

  // API Integration
  useEffect(() => {
    GetAllBuyers();
    getCountries();
  }, []);

  // get all Cities Request
  const getCountries = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllCountry', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setCountryData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Users Request
  const GetAllBuyers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllBuyers', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setBuyersData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  // post Request to Add new record
  const insertBuyers = async (newData) => {
    try {
      const res = await axios.instance.post('/InsertBuyerMstData', newData, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      GetAllBuyers();
      setAlertType('success');
      setAlertMessage(operation === 'Edit' ? 'Buyer updated Successfully!' : 'New Buyer Added Successfully!');
      setopenAlert(true);
    } catch (error) {
      console.error('Error adding User:', error);
      setAlertType('error');
      setAlertMessage(operation === 'Edit' ? 'Failed to Update the Buyer!' : 'Failed to add the Buyer!');
      setopenAlert(true);
    }
  };

  // delete Request to delete record
  const deleteBuyer = async (DelId) => {
    try {
      await axios.instance
        .delete(`/DeleteBuyerMstData/${DelId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            GetAllBuyers();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('Buyer Deleted Successfully!');
            setopenAlert(true);
          } else {
            GetAllBuyers();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);              
          }
          // console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting Buyer:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the Buyer.');
      setopenAlert(true);
    }
  };

  const resetFields = () => {
    setbuyerName('');
    setaddress('');
    setEmail('');
    setContactNo('');
    setActive('');
    errors.buyerName = false;
    errors.address = false;
    errors.Email = false;
    errors.contactNo = false;
    errors.Contactperson = false;
    errors.UserPassword = false;
    errors.Active = false;
    helperTexts.buyerName = '';
    helperTexts.address = '';
    helperTexts.Email = '';
    helperTexts.contactNo = '';
    helperTexts.Contactperson = '';
    helperTexts.Active = '';
    setSelectedCountry(null);
    setContactperson('');
  };

  // submit button on add or edit
  const handleSubmit = (event) => {
    event.preventDefault();

    const inputValidation =
      errors.buyerName ||
      errors.address ||
      errors.Email ||
      errors.Country ||
      errors.Contactperson ||
      errors.contactNo ||
      errors.Active ||
      !buyerName ||
      !address ||
      !Email ||
      !selectedCountry ||
      // !Contactperson ||
      // !contactNo ||
      !Active;

    if (inputValidation) {
      if (!buyerName) {
        setErrors((prevErrors) => ({ ...prevErrors, buyerName: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          buyerName: 'Please Enter Buyer Name',
        }));
      }
      if (!address) {
        setErrors((prevErrors) => ({ ...prevErrors, address: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          address: 'Please Enter Address',
        }));
      }
      if (!selectedCountry) {
        setErrors((prevErrors) => ({ ...prevErrors, Country: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Country: 'Please Select Country',
        }));
      }
      if (!Email) {
        setErrors((prevErrors) => ({ ...prevErrors, Email: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Email: 'Please Enter Email',
        }));
      }
      // if (!Contactperson) {
      //   setErrors((prevErrors) => ({ ...prevErrors, Contactperson: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     Contactperson: 'Please Enter Contact Person',
      //   }));
      // }
      // if (!contactNo) {
      //   setErrors((prevErrors) => ({ ...prevErrors, contactNo: true }));
      //   setHelperTexts((prevHelperTexts) => ({
      //     ...prevHelperTexts,
      //     contactNo: 'Please Enter Phone Number',
      //   }));
      // }
      if (!Active) {
        setErrors((prevErrors) => ({ ...prevErrors, Active: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Active: 'Please select Active Status',
        }));
      }
    }

    if (inputValidation) {
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      buyerName: false,
      address: false,
      Country: false,
      Email: false,
      Contactperson: false,
      contactNo: false,
      Active: false,
    }));

    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      buyerName: '',
      address: '',
      Country: '',
      Email: '',
      Contactperson: '',
      contactNo: '',
      Active: '',
    }));

    const newData = {
      optype: operation === 'Edit' ? 'Edit' : 'Add',
      Buyer_Id: operation === 'Edit' ? editID : '',
      Buyer_Name: buyerName,
      Address: address,
      Country: selectedCountry.id,
      Email_Id: Email,
      Contact_Person: Contactperson,
      Contact_No: contactNo,
      Active,
      [operation === 'Edit' ? 'ModifyedBy' : 'CreatedBy']: sessionStorage.getItem('UserID'),
    };
    insertBuyers(newData);

    // console.log('submitted', newData);

    // console.log('added data', newData);

    // if (operation === 'Add') {
    //   insertBuyers(newData);
    // } else if (operation === 'Edit') {
    //   console.log(editID, newData);
    //   EditBuyer(editID, newData);
    // }
    resetFields();
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const numericFields = ['contactNo'];
    
    if (numericFields.includes(name) && !/^\d*$/.test(value)) {
      return; 
    }
    if (name === 'buyerName') setbuyerName(value);
    if (name === 'address') setaddress(value);
    if (name === 'Email') setEmail(value);
    if (name === 'contactNo') setContactNo(value);
    if (name === 'Contactperson') setContactperson(value);
    if (name === 'Active') setActive(value);
    validateInput(name, value);
  };

  // validations

  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const contactRegex = /^\d{10}$/;
    const isDataExists = buyersData.some((data) => data.Buyer_Name.toLowerCase() === value.toLowerCase().trim());
    const isDataExistsinEdit = buyersData.some(
      (data) => data.Buyer_Name.toLowerCase() === value.toLowerCase().trim() && data.Buyer_Id !== editID
    );
    // console.log(isDataExists, isDataExistsinEdit, 'Name');

    if (name === 'buyerName') {
      if (!value.trim()) {
        error = true;
        helperText = 'Buyer Name field cannot be empty';
        setIsFormSubmitted(false);
      } else if (operation === 'Add' && isDataExists) {
        error = true;
        helperText = 'Buyer Name already exists';
        setIsFormSubmitted(false);
      } else if (operation === 'Edit' && isDataExistsinEdit) {
        error = true;
        helperText = 'Buyer Name already exists';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'address') {
      if (!value.trim()) {
        error = true;
        helperText = 'address  cannot be empty';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'Email') {
      if (!value.trim()) {
        error = true;
        helperText = 'email field cannot be empty';
        setIsFormSubmitted(false);
      } else if (!emailRegex.test(value)) {
        error = true;
        helperText = 'please enter a valid email';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'contactNo') {
      if (value.length > 0 && !contactRegex.test(value) && value.length > 10) {
        error = true;
        helperText = 'cannot exceed more than 10 numbers';
        setIsFormSubmitted(false);
      } else if (value.length > 0 && value.length < 10) {
        error = true;
        helperText = 'enter 10 digit mobile numbers';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }
    // else if (name === 'Contactperson') {
    //   if (!value.trim()) {
    //     error = true;
    //     helperText = 'Contact person field cannot be empty';
    //     setIsFormSubmitted(false);
    //   }
    //   else {
    //     setIsFormSubmitted(true);
    //   }
    // }
    else if (name === 'Active') {
      if (!value.trim()) {
        error = true;
        helperText = 'Plaese select user status';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      [name]: helperText,
    }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value.length > 0) {
      validateInput(name, value);
    }
  };

  // handle edit popup dialog
  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
  };

  const handleEdit = (datas) => {
    setEditID(datas.Buyer_Id);
    setbuyerName(datas.Buyer_Name);
    setaddress(datas.Address);
    setEmail(datas.Email_Id);
    setContactNo(datas.Contact_No);
    setContactperson(datas.Contact_Person);
    const selectedCountryObj = countryData.find((cntry) => parseInt(cntry.id, 10) === parseInt(datas.Country, 10));
    setSelectedCountry(selectedCountryObj);
    setActive(datas.Active);
    handleEditOpen();
    // console.log(selectedCountryObj, 'edit data', datas);
  };

  const handleEditOpen = () => {
    setOpen(true);
    setOperation('Edit');
  };

  const handleDelete = (idDel) => {
    setOpenDelete(true);
    setIdToDelete(idDel);
  };

  const handleDeleteConfirmed = (idtoDel) => {
    deleteBuyer(idtoDel);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    resetFields();
    setOpen(false);
  };

  // search & filter
  const filteredData = buyersData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  const handleInputChangeSelect = (event, newValue) => {
    setSelectedCountry(newValue);

    if (!newValue) {
      // Check if the newValue is null or undefined
      setErrors((prevErrors) => ({ ...prevErrors, Country: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Country: 'Please select a country' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, Country: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Country: '' }));
    }
  };

  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1)); // Clamp to the range [0, totalPages - 1]
  // Reset page to 0 when searchTerm changes
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Buyer Master
            </Typography>
          </Typography>
        </Grid>

        {/* search & add button */}
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <Button
            variant="outlined"
            color="secondary"
            sx={{ boxShadow: 1 }}
            onClick={handleAddOpen}
            startIcon={<PlaylistAddIcon />}
          >
            Add Buyer
          </Button>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Buyer Name</StyledTableCell>
                <StyledTableCell align="left">Address</StyledTableCell>
                <StyledTableCell align="left">Email</StyledTableCell>
                <StyledTableCell align="left">Contact</StyledTableCell>
                <StyledTableCell align="left">Phone</StyledTableCell>
                <StyledTableCell align="left">Country</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((datas, index) => (
                <TableRow key={datas.UserAccessID} hover>
                  <TableCell align="center">{datas.SNo}</TableCell>
                  <TableCell align="left">{datas.Buyer_Name}</TableCell>
                  <TableCell align="left">{datas.Address}</TableCell>
                  <TableCell align="left">{datas.Email_Id}</TableCell>
                  <TableCell align="left">{datas.Contact_Person}</TableCell>
                  <TableCell align="left">{datas.Contact_No}</TableCell>
                  <TableCell align="left">{datas.country_name}</TableCell>
                  <TableCell align="center">
                    {datas.Active === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton aria-label="Edit" onClick={() => handleEdit(datas)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(datas.Buyer_Id)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={9} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* add new popup form dialog box */}
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ py: 2 }}>
            <form onSubmit={handleSubmit} noValidate>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} pl={1} fontWeight={600} color="primary">
                  {operation} Buyer
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack direction={'column'} spacing={2} p={1}>
                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label={'Buyer Name'}
                  name="buyerName"
                  value={buyerName === null ? '' : buyerName}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  size="small"
                  error={errors.buyerName}
                  helperText={helperTexts.buyerName}
                  className={isFormSubmitted && errors.buyerName ? 'shake-helper-text' : ''}
                />

                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Address"
                  name="address"
                  value={address === null ? '' : address}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  multiline
                  rows={3}
                  required
                  error={errors.address}
                  helperText={helperTexts.address}
                  className={isFormSubmitted && errors.address ? 'shake-helper-text' : ''}
                />

                <Autocomplete
                  size="small"
                  name="Country"
                  options={countryData}
                  getOptionLabel={(cntry) => (cntry ? cntry.country_name : '')}
                  value={selectedCountry || null}
                  onChange={handleInputChangeSelect}
                  renderInput={(params) => <TextField {...params} label="Select Country" required />}
                />
                {errors.Country && (
                  <Typography
                    variant="caption"
                    color="error"
                    className={isFormSubmitted && errors.Country ? 'shake-helper-text' : ''}
                  >
                    {errors.Country && helperTexts.Country}
                  </Typography>
                )}

                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Email"
                  name="Email"
                  value={Email === null ? '' : Email}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  size="small"
                  error={errors.Email}
                  helperText={helperTexts.Email}
                  className={isFormSubmitted && errors.Email ? 'shake-helper-text' : ''}
                />

                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Contact Person"
                  name="Contactperson"
                  value={Contactperson === null ? '' : Contactperson}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  error={errors.Contactperson}
                  helperText={helperTexts.Contactperson}
                  className={isFormSubmitted && errors.Contactperson ? 'shake-helper-text' : ''}
                />

                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Contact No"
                  name="contactNo"
                  value={contactNo === null ? '' : contactNo}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  error={errors.contactNo}
                  helperText={helperTexts.contactNo}
                  className={isFormSubmitted && errors.contactNo ? 'shake-helper-text' : ''}
                />

                <FormControl size="small" fullWidth component="fieldset">
                  <FormLabel component="legend">Active Status</FormLabel>
                  <RadioGroup row value={Active} name="Active" onChange={handleInputChange}>
                    <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                    <FormControlLabel value="N" control={<Radio />} label="No" />
                  </RadioGroup>
                  {errors.Active && (
                    <Typography
                      variant="caption"
                      color="error"
                      className={isFormSubmitted && errors.Active ? 'shake-helper-text' : ''}
                    >
                      {errors.Active && helperTexts.Active}
                    </Typography>
                  )}
                </FormControl>
                <Button type="submit" variant="contained" color="primary" size="small" sx={{ boxShadow: 1 }} fullWidth>
                  Save
                </Button>
              </Stack>
            </form>
          </Container>
        </Dialog>
      </Grid>

      {/* confirmation dialog */}
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="responsive-dialog-title"
        fullScreen={fullScreen}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={() => handleDeleteConfirmed(IdToDelete)} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default BuyerMasters;
